export type BreadcrumbSize = 0 | 1 | 2 | 3;

export const getBreadcrumbSize = (containerWidth?: number): BreadcrumbSize | null => {
  if (containerWidth === undefined) return null;
  if (containerWidth < 360) return 0;
  if (containerWidth < 480) return 1;
  if (containerWidth < 560) return 2;
  return 3;
};
